/* Le Bon Masque - titre dynamique de la section "Composition" des fiches produit.
   Le script du bloc "Fiche produit detaillee" (product-info-card) filtre le slider
   selon la variante choisie et pose la classe .product-info-slider--single quand
   un seul produit distinct reste affiche. On s'aligne sur cette classe :
   1 produit  -> "Composition du produit"
   plusieurs  -> "Composition du pack"
   Les blocs texte vises portent les classes .lbm-compo-titre / .lbm-compo-sous-titre
   (reglage "Classe additionnelle" dans les templates produit). */
(function () {
  var LIBELLES = {
    single: {
      titre: 'Composition du produit',
      sous: 'Découvrez votre produit : texture, origine, ingrédients clés.'
    },
    pack: {
      titre: 'Composition du pack',
      sous: 'Découvrez chaque produit inclus dans votre pack : texture, origine, ingrédients clés.'
    }
  };

  /* La composition a-t-elle deja ete appliquee par product-info-card ?
     (il pose _lbmAllSlides sur <slider-component> au premier passage) */
  function compositionAppliquee(root) {
    var comp = root.querySelector('slider-component');
    return !!(comp && comp._lbmAllSlides);
  }

  function majTitre(root) {
    if (!compositionAppliquee(root)) return; /* texte statique du template conserve en attendant */
    var section = root.closest('.shopify-section') || document;
    var lib = root.classList.contains('product-info-slider--single') ? LIBELLES.single : LIBELLES.pack;
    var titre = section.querySelector('.lbm-compo-titre h1, .lbm-compo-titre h2, .lbm-compo-titre h3, .lbm-compo-titre p');
    if (titre && titre.textContent !== lib.titre) titre.textContent = lib.titre;
    var sous = section.querySelector('.lbm-compo-sous-titre p');
    if (sous && sous.textContent !== lib.sous) sous.textContent = lib.sous;
  }

  function passe() {
    var roots = document.querySelectorAll('.product-info-slider');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (!root.dataset.lbmCompoTitre) {
        root.dataset.lbmCompoTitre = '1';
        if (typeof MutationObserver === 'function') {
          (function (r) {
            new MutationObserver(function () { majTitre(r); })
              .observe(r, { attributes: true, attributeFilter: ['class'] });
          })(root);
        }
      }
      majTitre(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', passe);
  } else {
    passe();
  }
  document.addEventListener('shopify:section:load', passe);
  document.addEventListener('variant:updated', function () { setTimeout(passe, 300); });
  setTimeout(passe, 700);
  setTimeout(passe, 1800);
  setTimeout(passe, 3500);
})();
